<template>
	<div class="binding-body">
		<div class="search-box">
			<div class="input-box">
				<span>商品名称：</span>
				<el-input
					v-model="goodsName"
					placeholder="请输入商品名称"
					class="name-input"
					size="small"
					@keyup.enter.native="tableReload"
				></el-input>
			</div>
			<div class="input-box">
				<span>店铺级大类：</span>
				<el-select v-model="bcId" class="select-box" size='small' @change="bcChange">
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in bc">
						<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id" :disabled="item.disabledflag"/>
					</template>
				</el-select>
			</div>
			<div class="input-box" v-if="bigcategoryview === 1">
				<span>店铺级小类：</span>
				<el-select v-model="scId" class="select-box" size='small'>
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in sc">
						<el-option :value="item.id" :label="item.name" :key="item.id" :disabled="item.disabledflag"></el-option>
					</template>
				</el-select>
			</div>
			<div v-if='isCheckFlag' class="input-box">
				<span>审核状态：</span>
				<el-select v-model="auditState" class="select-box" size='small'>
					<el-option :value="4" label="全部"></el-option>
					<el-option :value="0" label="待提交"></el-option>
					<el-option :value="1" label="待审核"></el-option>
					<el-option :value="2" label="已通过"></el-option>
					<el-option :value="3" label="驳回"></el-option>

				</el-select>
			</div>
			<div class="input-box-btn">
				<el-button
					type="primary"
					class="search-btn"
					size="small"
					plain
					@click="tableReload">查询</el-button>
			</div>
		</div>
        <div class="table-box">
            <el-table
				:stripe='true'
				size='mini'
				ref='multipleTable'
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
				border
				@selection-change="handleSelectionChange">
				<el-table-column
				type="selection"
				align="center"
				width="55">
				</el-table-column>
				<el-table-column
					label-class-name = "column-index"
					label="序号"
					type="index"
					width="70"
					align="center">
				</el-table-column>
				<el-table-column
						prop="goodsname"
						label="商品名称"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="code"
						label="商品编号"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="bcname"
						label="店铺级大类"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						v-if="bigcategoryview === 1"
						prop="scname"
						label="店铺级小类"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="auditstate"
						label="审核状态"
						v-if='isCheckFlag'
						align="center"
						min-width="180">
					</el-table-column>
			</el-table>
			<div class="page-box">
				<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page.number"
				:page-sizes="[20,40, 60, 100]"
				:page-size="page.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
			</div>
        </div>
         <div class="binding-foot">
            <el-button class="btn" plain type="primary" @click="cancelClick">取消</el-button>
            <el-button class="btn" plain type="primary" @click="saveClick">保 存</el-button>
        </div>
	</div>
</template>
<script>
export default {
	name: 'binding',
	props: {
		sessionStoreId: String,
		isShow: Boolean,
		isCheckFlag: Boolean
	},
	data () {
		return {
			bc: [],
			sc: [],
			shopId: '',
			bcId: '0',
			scId: '0',
			auditState: 4,
			goodsName: '',
			tableData: [],
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			isCheck: {},
			checkArr: [],
			pageList: [],
			tableHeight: '90%',
			bigcategoryview: 0
		}
	},
	watch: {
		isShow: {
			handler (val) {
				if (val === true) {
					this.shopId = this.sessionStoreId
					this.getBigCategory()
					if (this.bigcategoryview === 1) {
						this.getSmalCategory()
					}
					this.tableReload()
				} else {
					this.goodsName = ''
					this.bcId = '0'
					this.scId = '0'
					this.auditState = 4
				}
			},
			immediate: true
		}
	},
	created () {
		this.checkSmallCategory().then(res => {
			this.bigcategoryview = res.bigcategoryview
		})
	},
	methods: {
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		bcChange (value) {
			this.scId = '0'
			this.bcId = '' + value
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		toggleSelection () {
			let toggArr = []
			let tempData = this.isCheck[this.page.number]
			if (tempData !== null && tempData.length > 0) {
				for (let i = 0; i < tempData.length; i++) {
					for (let j = 0; j < this.tableData.length; j++) {
						if (tempData[i].goodsid === this.tableData[j].goodsid) {
							toggArr.push(this.tableData[j])
						}
					}
				}
			}
			if (toggArr) {
				toggArr.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row)
				})
			} else {
				this.$refs.multipleTable.clearSelection()
			}
		},
		tableReload () {
			let params = {
				id: 0,
				shopId: this.shopId,
				bcId: this.bcId,
				scId: this.scId,
				comFlag: 1,
				hiddenFlag: -1,
				stackFlag: 2,
				saleState: 2,
				goodsName: this.goodsName,
				auditState: this.auditState,
				page: this.page.number,
				size: this.page.size,
				sourceflag: -1,
				unitFlag: -1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/relation/getRelationGoodsInfo`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableData = res.data.recordList
					this.total = res.data.recordCount
					this.$nextTick(function () {
						if (this.isCheck[this.page.number]) {
							this.toggleSelection()
						}
						this.$refs.multipleTable.doLayout()
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSelectionChange (val) {
			this.isCheck[this.page.number] = val
			this.pageList.push(this.page.number)
			let array = this.pageList
			var temp = [] // 一个新的临时数组
			for (var i = 0; i < array.length; i++) {
				if (temp.indexOf(array[i]) === -1) {
					temp.push(array[i])
				}
			}
			this.pageList = temp
			console.log(this.isCheck)
		},
		cancelClick () {
			this.$emit('update:dialogVisible', false)
			this.$emit('update:isShow', false)
		},
		saveClick () {
			let arr = ''
			this.checkArr = []
			if (this.pageList.length > 0) {
				for (let i = 0; i < this.pageList.length; i++) {
					let b = this.isCheck[this.pageList[i]]
					for (let j = 0; j < b.length; j++) {
						this.checkArr.push(b[j].id)
					}
				}
			}
			arr = this.checkArr.join(',')
			if (this.checkArr.length === 0) {
				this.$message.error('请选择至少一个商品！')
				return false
			}
			let params = {
				shopIds: this.sessionStoreId,
				ids: arr
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/goods/saveShopRelationGoods`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$emit('cancel', false)
					this.$message.success('添加商品成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
    display: flex;
    width :950px;
	flex-direction: column;
    height :400px;
    overflow-y :auto;
	.search-box{
		margin-bottom :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :80px;
		}
		.input-box{
			margin-left :10px;
			width :215px;
			margin-bottom:10px
			.name-input {
				width: 120px;
				margin-right: 10px;
			}
			.select-box{
				width:120px;
				margin-right:10px;
			}
		}
	}
    .table-box{
		width :100%;
        padding-bottom :10px;
        height:calc(100% - 130px);
		.page-box{
			text-align :center
		}
    }
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
		margin-top:10px;
        margin-bottom :10px;
        width :100%
        .btn{
            width :35%;
			margin-left:95px;
        }
    }
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
